import { TableHead } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import axios from "axios";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import "./AdminComponents.scss";
import { toast } from "react-toastify";

function ClientDetails({ refreshList }) {
  const [clientList, setClientList] = useState([]);
  const [userData, setUserData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const clientListWithId = clientList.map((client, index) => ({
    ...client,
    id: index + 1,
  }));
  const history = useHistory();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     (sessionStorage.getItem("roleType") !== "admin" &&
  //       sessionStorage.getItem("roleType") !== "partner admin")
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    const roleType = sessionStorage.getItem("roleType");
    const facilityName = sessionStorage.getItem("facility_name");
    const customerName = sessionStorage.getItem("customer_name");
    const partnerId = sessionStorage.getItem("partner_id");

    const post_data = {
      role_type: roleType,
      facility_name: facilityName,
      customer_name: customerName,
      partner_id: partnerId,
    };
    if (
      (sessionStorage.getItem("roleType") === "admin" ||
        sessionStorage.getItem("roleType") === "partner admin") &&
      Token()
    ) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_clients/`, {
          headers: headers,
        })
        .then((res) => {
          console.log(res.data);
          setClientList(res.data.client_list);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
    console.log("ddd", clientListWithId);
  }, [authToken, refreshList]);
  const getRowClassName = (params) => {
    return "custom-row";
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "auto",
        width: "100%",
        maxWidth: "1200px", // Set a max width for large screens
        padding: "1rem",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Customer List</h1>
      <div style={{ width: "100%" }}>
        <DataGrid
          rows={clientListWithId}
          columns={[
            { field: "id", headerName: "ID", width: 80 },
            { field: "client_name", headerName: "Company Name", width: 200 },
            { field: "client_email", headerName: "Company Email", width: 200 },
            { field: "phone", headerName: "Phone", width: 150 },
            // { field: 'address_line', headerName: 'Address Line', width: 200 },
            // { field: 'address_city', headerName: 'City', width: 150 },
            // { field: 'address_state', headerName: 'State', width: 150 },
            // { field: 'address_pincode', headerName: 'Pincode', width: 120 },
            {
              field: "registration_no",
              headerName: "Registration No.",
              width: 180,
            },
            {
              field: "date_of_creation",
              headerName: "Date of Creation",
              width: 200,
            },
            {
              field: "active",
              headerName: "Active",
              width: 100,
              renderCell: (params) => (
                <div
                  style={{
                    color: params.value ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {params.value ? "Active" : "Inactive"}
                </div>
              ),
            },
          ]}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[5, 10]}
          getRowId={(row) => row.id}
          components={{
            Toolbar: () => (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  <GridToolbarColumnsButton />
                  <GridToolbarFilterButton />
                  <GridToolbarDensitySelector />
                </div>
              </div>
            ),
          }}
          getRowClassName={getRowClassName}
        />
      </div>
    </div>
  );
}

export default ClientDetails;
